var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Tooltip } from "@mui/material";
import { combineSxProps, commonTooltipProps } from "../../Utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons/faInfoCircle";
const attentionBoxTitleContainerSxProps = {
    display: "flex",
    flexGrow: 1,
    gap: "4px",
    alignItems: "center",
    color: "text.primary",
    paddingLeft: "24px",
    paddingTop: "5px",
    paddingBottom: "5px"
};
export const AttentionBoxTitle = (props) => {
    const { children, informationTooltip, sx } = props, boxProps = __rest(props, ["children", "informationTooltip", "sx"]);
    return (_jsxs(Box, Object.assign({}, boxProps, { sx: combineSxProps(attentionBoxTitleContainerSxProps, sx), children: [children, informationTooltip ? (_jsx(Tooltip, Object.assign({}, commonTooltipProps, { title: informationTooltip, children: _jsx(FontAwesomeIcon, { icon: faInfoCircle, style: { fontSize: "12px", color: "default", alignItems: "baseline" } }) }))) : null] })));
};
//# sourceMappingURL=AttentionBoxTitle.js.map